// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {oculus_img_url} from '../../../../hola/pub/ui/oculus_img_url';
import {Button} from '../../lib/button';
import Icon_arrow_right from '../../img/icons/24/arrow_right.svg';
import styles from './manage_product.module.less';

export const Manage_product = ()=>{
    return <div className={styles.manage_product}>
      <div className={styles.container}>
        <div data-part="img">
          <img src={oculus_img_url('products/product_dashboard.png')}/>
        </div>
        <div data-part="content">
          <p data-part="title">Manage everything through your dashboard</p>
          <p data-part="text">
            The platform allows you to create multiple proxy users, oversee
            your subscription, and access all available resources-providing
            a comprehensive solution in a single location.
          </p>
          <div data-part="cta">
            <Button
              caption={<>Go to your dashboard <Icon_arrow_right/></>}
              to="/dashboard"
            />
          </div>
        </div>
      </div>
    </div>;
};
